//library
import { useCallback, useMemo } from "react";

// hooks
import useTemplateContext from "hooks/use-template-context";

import formatDate from "common/format-date";

import { AppArticleInfoDto } from "dto/components/app-article-info/app-article-dto";

const AppArticleInfo = ({ publicationDate, category, tableOfContent, location }: AppArticleInfoDto) => {
	const formattedPublicationDate = formatDate(publicationDate);

	const { getFilteredResources } = useTemplateContext();
	const connectPage = useMemo(() => getFilteredResources("page.article"), [getFilteredResources]);
	const getPageData = useCallback((key: string) => connectPage?.find((value) => value.key === key)?.value?.toString() ?? "", [connectPage]);
	const articlePublicationDate = useMemo(() => getPageData("page.article.publicationDate"), [getPageData]);
	const articleCategory = useMemo(() => getPageData("page.article.category"), [getPageData]);
	const articleLocation = useMemo(() => getPageData("page.article.location"), [getPageData]);
	const articleTableOfContent = useMemo(() => getPageData("page.article.tableOfContents"), [getPageData]);
	
	return (
		<div className="app-article-info">
			<div className="article-info">
				<div className="article-info__header">
					<div className="article-info__block">
						<p className="article-info__title">{articlePublicationDate}</p>
						<p className="article-info__description">{formattedPublicationDate}</p>
					</div>

					<div className="article-info__block">
						<p className="article-info__title">{articleCategory}</p>
						<p className="article-info__description">{category}</p>
					</div>
				</div>

				<div className="article-info__subheader">
					<div className="article-info__section">
						<p className="article-info__title">{articleLocation}</p>
						<p className="article-info__description">{location}</p>
					</div>
				</div>

				<div className="article-info__content">
					<p className="article-info__title">{articleTableOfContent}</p>
					<ul className="article-info__description">
						{tableOfContent?.map((desc: string, index: number) => (
							<li key={index}>{desc}</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};
export default AppArticleInfo;
